<div class="offline-container popup-container center">
  <mat-icon *ngIf="!data.spinner">sensors_off</mat-icon>
  <mat-spinner *ngIf="data.spinner"></mat-spinner>
  <h2>{{environment.enableDesktopMode ? "Connexion au player perdue" : data.title | async}}</h2>
</div>
